import axios from 'axios';
import * as Content from '@/data/content';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const deep = (v) => JSON.parse(JSON.stringify(v));

export const EDITABLE_KEYS = [
  'CONTACT', 'ASSETS', 'NAV_LINKS', 'HERO', 'STATS', 'WHY_FEATURES', 'PHILOSOPHY_VALUES',
  'PHILOSOPHY_STEPS', 'AGE_GROUPS', 'PACKAGES', 'PROGRAMS', 'PATHWAY', 'PATHWAY_DESTINATIONS',
  'COACHES', 'SMALL_GROUP_BENEFITS', 'CHARACTER_VALUES', 'PARENT_PROMISE', 'PROGRESS_SKILLS',
  'TESTIMONIALS', 'GALLERY', 'EVENTS', 'TRYOUT', 'PROGRAM_OPTIONS', 'MARQUEE_ITEMS',
];

export const DEFAULTS = Object.fromEntries(EDITABLE_KEYS.map(k => [k, deep(Content[k])]));

function mergeInto(target, value) {
  if (value === null || value === undefined) return;
  if (Array.isArray(target)) {
    if (!Array.isArray(value)) return;
    const sameLen = target.length === value.length;
    value.forEach((v, i) => {
      if (sameLen && typeof target[i] === 'object' && target[i] !== null && typeof v === 'object' && v !== null) {
        Object.assign(target[i], v);
      } else if (i < target.length) {
        target[i] = v;
      } else {
        target.push(v);
      }
    });
    target.length = value.length;
  } else if (typeof target === 'object' && target !== null && typeof value === 'object') {
    Object.keys(target).forEach(k => { if (!(k in value)) delete target[k]; });
    Object.assign(target, value);
  }
}

export function applySection(key, data) {
  if (EDITABLE_KEYS.includes(key) && Content[key] !== undefined) mergeInto(Content[key], data);
}

export async function loadRemoteContent() {
  try {
    const { data } = await axios.get(`${API}/content`);
    Object.entries(data.sections || {}).forEach(([key, val]) => applySection(key, val));
  } catch (e) {
    // static defaults remain
  }
}
